import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ItemsSelectorComponent } from './items-selector/items-selector.component';
import { SeSelectorWebComponent } from './se-selector-web/se-selector-web.component';
import { SelectedItemsVisualizerComponent } from './selected-items-visualizer/selected-items-visualizer.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatBadgeModule } from '@angular/material/badge';

import { SelectedItemsVisualizerOverlayComponent } from './selected-items-visualizer-overlay/selected-items-visualizer-overlay.component';
import { SelectorToolbarComponent } from './items-selector/selector-toolbar/selector-toolbar.component';
import { GroupToolbarComponent } from './items-selector/group-toolbar/group-toolbar.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    SeSelectorWebComponent,
    ItemsSelectorComponent,
    SelectedItemsVisualizerComponent,
    SelectedItemsVisualizerOverlayComponent,
    SelectorToolbarComponent,
    GroupToolbarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTreeModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatRadioModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatToolbarModule,
    MatDividerModule,
    MatSnackBarModule,
    MatBadgeModule,
    TranslateModule
  ],
  exports: [
    SeSelectorWebComponent,
    SelectedItemsVisualizerComponent,
    SelectedItemsVisualizerOverlayComponent
  ]
})
export class SeUiSelectorWebModule { }
